
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["zoneSelect"]

  static values = {
    findZoneUrl: { type: String, default: "/api/v1/zones/find_zone_by_address" }
  }

  connect () {
    this.onAddressChange = this.onAddressChange.bind(this)
    this.element.addEventListener("address-autocomplete:change", this.onAddressChange)
  }

  disconnect () {
    this.element.removeEventListener("address-autocomplete:change", this.onAddressChange)
  }

  async onAddressChange (event) {
    const { latitude, longitude } = event.detail || {}

    if (!latitude || !longitude || !this.hasZoneSelectTarget) return

    try {
      const response = await fetch(this.findZoneUrlValue, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
        },
        body: JSON.stringify({ localisation: { latitude, longitude } })
      })

      if (!response.ok) return

      const payload = await response.json()
      const zoneId = payload.data?.id

      if (!zoneId) return

      this.zoneSelectTarget.value = zoneId
      this.zoneSelectTarget.dispatchEvent(new Event("change", { bubbles: true }))
    } catch (error) {
      console.error("Zone by address lookup failed:", error)
    }
  }
}
